import React, { Suspense } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import { SuspenseLoader } from '../common/components/SuspenseLoader';

const UnsubscribeEmail = React.lazy(() =>
  import(/* webpackChunkName: "UnsubscribeEmail" */ './UnsubscribeEmail')
);

export default () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Switch>
        <Route path="/" exact component={UnsubscribeEmail} />
        <Redirect to="/" />
      </Switch>
    </Suspense>
  );
};
